<template>
  <div class="home" ref="home">
    <Header></Header>

    <van-tabs v-model="active">
      <van-tab title="奋斗者">
        <div class="list">
          <div class="item">
            <van-checkbox-group
              v-model="result"
              :max="10"
              @change="onCheckChange"
            >
              <div class="item" v-for="item in list" :key="item.id">
                <van-checkbox :name="item.id" checked-color="#cb2917">
                </van-checkbox>
                <div class="img-wrap">
                  <img v-lazy="item.url" @click="onItemClick(item)" />
                </div>
                <div class="info">
                  <div class="name">{{ item.title }}</div>
                  <div class="intr">{{ item.identity }}</div>
                </div>

                <div class="votes">{{ item.votes }}票</div>
              </div>
            </van-checkbox-group>
          </div>
          <div class="pos"></div>
        </div>

        <van-button class="submit" @click="onSubmit">
          <span>提交点赞</span>
        </van-button>
      </van-tab>
      <van-tab title="排行榜">
        <Rank :rankList="rankList"></Rank>
      </van-tab>
    </van-tabs>

    <van-dialog
      v-model="showDialog"
      title="请输入验证码"
      :before-close="beforeClose"
      show-cancel-button
    >
      <div class="verify">
        <van-field v-model="code" placeholder="在此输入验证码"></van-field>
        <img :src="codeUrl" alt="" @click="onUpdateCode" />
      </div>
    </van-dialog>

    <div class="message" v-if="showCount">已选{{ result.length }}/10</div>
  </div>
</template>
<script>
import Header from "./components/Header";
import Rank from "./components/Rank";
import axios from "axios";
import { debounce } from "lodash";
import { getWorksList, worksVote, getVoteRankList } from "@/api/home";
export default {
  name: "home",
  components: {
    Rank,
    Header,
  },
  data() {
    return {
      showDialog: false,
      showCount: false,
      active: 0,
      result: [],
      list: [
        {
          id: 1,
          url: "123123123",
          title: "标题标题",
          identity: "介绍介绍",
          votes: 10086,
        },
        {
          id: 1,
          url: "123123123",
          title: "标题标题",
          identity: "介绍介绍",
          votes: 10086,
        },
        {
          id: 1,
          url: "123123123",
          title: "标题标题",
          identity: "介绍介绍",
          votes: 10086,
        },
        {
          id: 1,
          url: "123123123",
          title: "标题标题",
          identity: "介绍介绍",
          votes: 10086,
        },
        {
          id: 1,
          url: "123123123",
          title: "标题标题",
          identity: "介绍介绍",
          votes: 10086,
        },
      ],
      rankList: [],

      codeUrl: "",
      code: "",

      isIos: false,

      timestamp: "",
      nonceStr: "",
      signature: "",
    };
  },
  watch: {
    result() {
      if (this.result.length == 0) {
        this.showCount = false;
      } else {
        this.showCount = true;
      }
    },
  },
  methods: {
    beforeClose(action, done) {
      console.log(action);
      if (action === "cancel") {
        return done(true);
      } else {
        this.vote(action, done);
      }
    },

    onCheckChange() {
      // if(this.result.length>5){
      //   this.$toast('一次选五个')
      // }
    },

    onItemClick(item) {
      this.$router.push({
        path: "/detail",
        query: {
          item: JSON.stringify(item),
        },
      });
    },

    onUpdateCode() {
      this.getImgCode();
    },

    onSubmit() {
      if (SmartCity.isSmartCityApp()) {
        if (this.result.length < 10) {
          return this.$toast("请先选择十位点赞");
        }

        this.showDialog = true;
        this.getImgCode();
      } else {
        this.goApp();
      }
    },

    async vote(action, done) {
      if (!this.code) {
        done(false);

        return this.$toast("请输入验证码");
      }

      const { data: res } = await worksVote({
        token: this.$store.state.nthUserInfo.userTokenKey,
        code: this.code,
        worksIdStr: this.result.join(";"),
      });

      if (res.code == 200) {
        done(true);
        this.result = [];
        this.code = "";
        this.$toast.success(res.mes);
        this.getWorksList();

        this.getVoteRankList();
      } else {
        done(true);
        this.code = "";
        return this.$toast.fail(res.mes);
      }
    },

    getImgCode() {
      axios({
        method: "post",

        headers: {
          Authorization: "Bearer " + this.$store.state.token,
        },
        url: "https://vote.zhijianmedia.cn/home/getImgCode",
        data: {
          token: this.$store.state.nthUserInfo.userTokenKey,
        },
        responseType: "arraybuffer",
      }).then((res) => {
        this.codeUrl =
          "data:image/png;base64," +
          btoa(
            new Uint8Array(res.data).reduce(
              (data, byte) => data + String.fromCharCode(byte),
              ""
            )
          );
      });
    },

    async getWorksList() {
      const { data: res } = await getWorksList();
      if (res.code != 200) {
        return this.$toast(res.mes);
      } else {
        console.log(res);
        this.list = res.data;
      }
    },
    async getVoteRankList() {
      const { data: res } = await getVoteRankList();
      if (res.code != 200) {
        return this.$toast(res.mes);
      } else {
        console.log(res);
        this.rankList = res.data;
      }
    },
    goApp() {
      if (this.isIos) {
        window.location.href =
          "http://share.plus.hugd.com/app/jump/2021/hzr/ios";
      } else {
        window.location.href =
          "http://share.plus.hugd.com/app/jump/2021/hzr/android";
      }
    },
  },
  mounted() {
    this.getWorksList();
    this.getVoteRankList();
    var u = navigator.userAgent;
    var ua = u.toLowerCase();
    if (/iphone|ipad|ipod/.test(ua)) {
      this.isIos = true;
    }
  },

  created() {},
  activated() {},
  deactivated() {},
};
</script>
<style lang="less" scoped>
.home {
  width: 100%;
  background: #f5ebe8;
  .list {
    .van-checkbox-group {
      width: 100%;
      display: flex;
      flex-wrap: wrap;

      justify-content: space-between;
      padding: 10px;

      .item {
        width: 172px;
        height: 350px;
        position: relative;
        margin-bottom: 10px;
        border-radius: 0.1rem;

        border: 1px solid @main;
        .img-wrap {
          width: 172px;
          height: 200px;

          background: #fff;

          img {
            border-radius: 0.1rem;

            width: 100%;
            height: 100%;
          }
        }

        .info {
          padding: 10px;

          .name {
            margin-bottom: 4px;
          }
          .intr {
            font-size: 12px;
          }
        }
        .votes {
          right: 7%;
          bottom: 7%;
          position: absolute;
          z-index: 100;
        }
        .van-checkbox {
          bottom: 7%;
          left: 7%;
          position: absolute;
          z-index: 100;
        }
      }
    }

    .pos {
      height: 100px;
    }
  }

  .submit {
    width: 100%;
    height: 66px;
    position: fixed;
    z-index: 100;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: @main;
    line-height: 1.2rem;
    text-align: center;
    color: #f2f2f2;
    span {
      font-size: 18px;
      font-weight: bold;
    }
  }
}

/deep/.van-checkbox__icon {
  background: #fff;
  border-radius: 50%;
  font-size: 30px;
}

// /deep/.van-icon-success:before {
//     content: '';
// }

.verify {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 2rem;
  padding: 0.4rem;
  .van-filed {
    width: 60% !important;
  }
  img {
    width: 35%;
  }
}

.message {
  position: fixed;
  right: 10px;
  bottom: 100px;

  line-height: 0.6rem;
  padding: 0.2rem 0.2rem;
  border-radius: 0.1rem;
  background-color: @main;
  opacity: 0.9;

  color: #f2f2f2;
}

/deep/.van-tab {
  color: #646566;
  font-size: 0.37333rem;
  line-height: 0.53333rem;
  cursor: pointer;
}

/deep/.van-tabs--line .van-tabs__wrap {
  height: 1.17333rem;
  margin: 20px;
  border-radius: 32px;
}

/deep/.van-tabs {
}
/deep/.van-tabs--line .van-tabs__wrap {
  height: 34px;
}

/deep/.van-tab {
  color: @main;
}
/deep/.van-tab--active {
  color: #fff;
  font-weight: 500;
  font-size: 16px;
  background: @main;
}

/deep/.van-tabs__line {
  background: none;
}
</style>
